var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgPw = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.331h512v341.337H0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 218.902,
  cy: 255.994,
  r: 74.207,
  fill: "#ffda44"
})));

export default SvgPw;